module.exports = __webpack_public_path__ + "static/Logo_York_University-faeecd27dc98f016860370477fbefd40.svg";